// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { RichTextMenu } from '@puckeditor/core';

const StyledRichText = styled.div`
  width: 100%;
  box-sizing: border-box;

   p {
    margin: 0;
  }

  h1, h2, h3 {
    margin: 0 0 0.5rem 0;
    line-height: 1.2;
  }

  h1 { font-size: 2.5rem; }
  h2 { font-size: 2rem; }
  h3 { font-size: 1.5rem; }
  h4 { font-size: 1.25rem; margin: 0 0 0.5rem; line-height: 1.2; }
  h5 { font-size: 1.1rem; margin: 0 0 0.5rem; line-height: 1.2; }
  h6 { font-size: 1rem; margin: 0 0 0.5rem; line-height: 1.2; }

  strong, b {
    font-weight: 600;
  }

  ul {
    list-style: disc;
    margin: 0.5rem 0;
    padding-left: 1.5rem;
  }

  li + li {
    margin-top: 0.25rem;
  }

  li p {
    margin: 0;
  }
`;

const RichText = {
  label: 'Rich Text',
  fields: {
    text: {
      type: 'richtext',
      contentEditable: true,
      options: {
        bulletList: {},
        orderedList: false,
        listItem: {},
        listKeymap: {},
        textAlign: false,
      },
      renderMenu: () => (
        <RichTextMenu>
          <RichTextMenu.Group>
            <RichTextMenu.HeadingSelect />
          </RichTextMenu.Group>
          <RichTextMenu.Group>
            <RichTextMenu.Bold />
            <RichTextMenu.Italic />
            <RichTextMenu.Underline />
            <RichTextMenu.Strikethrough />
          </RichTextMenu.Group>
          <RichTextMenu.Group>
            <RichTextMenu.BulletList />
          </RichTextMenu.Group>
        </RichTextMenu>
      ),
    },
    color: {
      type: 'text',
      label: 'Text color',
    },
    textAlign: {
      type: 'radio',
      options: [
        { label: 'Left', value: 'left' },
        { label: 'Center', value: 'center' },
        { label: 'Right', value: 'right' },
      ],
    },
    paddingTop: {
      type: 'select',
      options: [
        { label: 'None', value: '0' },
        { label: 'Small', value: '1rem' },
        { label: 'Medium', value: '2rem' },
        { label: 'Large', value: '4rem' },
      ],
    },
    paddingBottom: {
      type: 'select',
      options: [
        { label: 'None', value: '0' },
        { label: 'Small', value: '1rem' },
        { label: 'Medium', value: '2rem' },
        { label: 'Large', value: '4rem' },
      ],
    },
  },
  defaultProps: {
    text: '<p>Enter your text here.</p>',
    color: '#000000',
    textAlign: 'left',
    paddingTop: '0',
    paddingBottom: '0',
  },
  render: ({ text, color, textAlign, paddingTop, paddingBottom }) => (
    <StyledRichText style={ { color, textAlign, paddingTop, paddingBottom } }>
      {text}
    </StyledRichText>
  ),
};

// eslint-disable-next-line import/prefer-default-export
export { RichText };
